<template>
    <div>
        <Header/>
        <Empty class="content" :noFound="noFound" comment="用户不存在">
            <Title class="card" :name="username" :id="userid" :avatar="avatarURL"
                :hasFollow="hasFollow" :canFollow="canFollow" @follow="follow"
            >
                <div class="stat-card-mobile">
                    <a-row v-for="item of achievement" :key="item.id" :gutter="16" class="achievement">
                        <a-col v-if="item.type == 'text'" :title="item.details" :offset="2">
                            <a-icon :type="getIcon(item.classification)"></a-icon>
                            <span >{{ item.name }}</span>
                        </a-col>
                    </a-row>
                    <a-row v-if="top > 0" class="achievement">
                        <a-col :offset="2">
                            <a-icon type="to-top"></a-icon>
                            <span>拥有 {{ top }} 个榜单</span>
                        </a-col>
                    </a-row>
                    <a-row v-if="isSponsor" class="achievement">
                        <a-col :offset="2">
                            <a-icon type="money-collect" />
                            <span>网站赞助者</span>
                        </a-col>
                    </a-row>
                    <a-row :gutter="16" class="follow-stat">
                        <a-col :span="12" class="need-divider">
                            <span>关注了 {{ followees }} 人</span>
                        </a-col>
                        <a-col :span="12">
                            <span>关注者 {{ followers }} 人</span>
                        </a-col>
                    </a-row>
                </div>
            </Title>
            <main class="adjuster">
                <a-card
                    class="card record-card"
                    :tab-list="tabList"
                    :active-tab-key="$route.name"
                    @tabChange="change"
                >
                    <span slot="tab" slot-scope="item" class="tab-header">
                        <span>{{ item.name }}</span>
                        {{ item.data }}
                    </span>
                    <router-view class="tab-view"></router-view>
                </a-card>
                <div class="card stat-card">
                    <a-divider orientation="left">成就</a-divider>
                    <a-row v-for="item of achievement" :key="item.id" :gutter="16" class="achievement">
                        <a-col v-if="item.type == 'text'" :title="item.details" :offset="2">
                            <a-icon :type="getIcon(item.classification)"></a-icon>
                            <span >{{ item.name }}</span>
                        </a-col>
                    </a-row>
                    <a-row v-if="top > 0" class="achievement">
                        <a-col :offset="2">
                            <a-icon type="to-top"></a-icon>
                            <span>拥有 {{ top }} 个榜单</span>
                        </a-col>
                    </a-row>
                    <a-row v-if="isSponsor" class="achievement">
                        <a-col :offset="2">
                            <a-icon type="money-collect" />
                            <span>网站赞助者</span>
                        </a-col>
                    </a-row>
                    <a-divider orientation="left">数据</a-divider>
                    <a-row :gutter="16" class="follow-stat">
                        <a-col :span="12" class="need-divider">
                            <a-statistic title="关注了" :value="followees"></a-statistic>
                        </a-col>
                        <a-col :span="12">
                            <a-statistic title="关注者" :value="followers"></a-statistic>
                        </a-col>
                    </a-row>
                </div>
            </main>
        </Empty>
    </div>
</template>

<script>
import Header from '@/components/Header'
import Empty from '@/components/Empty'
import Title from './components/Title.vue'
import { mapActions, mapState } from 'vuex';

export default {
    computed: {
        ...mapState({ hasLogin: 'hasLogin', selfid: 'userid' }),
        ...mapState('$user', [
            'username', 'avatarURL', 'userid', 'followers', 'followees', 'hasFollow',
            'win', 'score', 'tower', 'comment', 'achievement', 'top', 'isSponsor', 'noFound',
        ]),
        tabList() {
            return [
                { key: 'score', name: '过关', data: `${ this.win } / ${ this.score }` },
                { key: 'tower', name: '作品', data: `${ this.tower }` },
                { key: 'comment', name: '发言', data: `${ this.comment }` },
            ].map(e => ({ ...e, scopedSlots: { tab: 'tab' } }));
        },
        canFollow() {
            if (!this.hasLogin) return false;
            if (this.selfid == this.userid) return false;
            return true;
        },
    },
    methods: {
        ...mapActions('$user', [ 'follow' ]),
        get(...args) {
            console.log(args);
        },
        change(key) {
            this.$router.push({ name: key });
        },
        getIcon(classification) {
            switch(classification) {
                case '身份': return 'idcard';
                case '拆塔比赛': return 'trophy';
                case '造塔比赛': return 'trophy';
                case '限时活动': return 'team';
                case '造塔活动': return 'team';
                case '比赛主办': return 'schedule';
                case '比赛协力': return 'schedule';
            }
        },
    },
    watch: {
        username(val) {
            document.title = `${ val }的主页 - H5魔塔广场`;
        }
    },
    components: {
        Header, Empty, Title
    }
}
</script>

<style lang="less">
body {
    background-color: #e6e6e6 !important;
    min-width: 1000px;
}
@media screen and (max-width: 800px) {
    body {
        min-width: 100%;
    }
}
</style>

<style lang="less" scoped>
.content {
    font-family: none;
    width: 1000px;
    margin: auto;
}
.adjuster {
    display: flex;
}
.card {
    background-color: #f6f6f6;
    border-radius: 2px;
    -webkit-box-shadow: 0 1px 3px rgba(18,18,18,.1);
    box-shadow: 0 1px 3px rgba(18,18,18,.1);
    margin: 6px;
}
.record-card {
    width: 736px;
    .tab-header {
        color: rgba(0, 0, 0, 0.45);
        font-weight: 500;
        span {
            color: rgba(0, 0, 0, 0.85);
            font-size: 18px;
        }
    }
    .ant-tabs-tab-active .tab-header span {
        font-weight: 800;
    }
}
.stat-card-mobile, .stat-card {
    .achievement {
        padding: 3px;
        font-size: 16px;
        .anticon {
            padding: 4px;
        }
    }
}
.stat-card {
    padding: 10px;
    width: 240px;
    height: fit-content;
}
.follow-stat {
    text-align: center
}
.need-divider {
    border-right: 1px solid #DDDDDD;
}
@media screen and (min-width: 800px) {
    .stat-card-mobile {
        display: none;
    }
}
@media screen and (max-width: 800px) {
    .content {
        width: 100%;
    }
    .stat-card {
        display: none;
    }
    .record-card {
        width: 100%;
    }
    .tab-view {
        overflow-x: auto;
    }
    .card {
        margin: 0 0 10px;
    }
}
</style>